export default __webpack_public_path__ + "static/DarianL-ca05b3af431ba144c37989605c8b61f9.png";